import React from "react";
import { createPortal } from "react-dom";

const RegStepItemDeleteInfoModal = ({
  isOpen,
  onClose,
  message = "Contact removed from the list. Click 'Save Contacts' to delete permanently or add another contact to continue.",
}) => {
  if (!isOpen) return null;

  return createPortal(
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="mb-0">Contact Removed</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body text-center">
            <i className="fa fa-info-circle fs-3 text-danger mb-2"></i>
            <p className="mb-0 px-5">{message}</p>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-sm btn-primary"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default RegStepItemDeleteInfoModal;
